import { Injectable } from '@angular/core';

import { Mutation, gql } from 'apollo-angular';

import { CreateCartPayload, MutationCreateCartArgs } from '@hdms/shared/common-types';

export interface CreateCartResponse {
  createCart: CreateCartPayload;
}

@Injectable({
  providedIn: 'root'
})
export class CreateCartGqlService extends Mutation<CreateCartResponse, MutationCreateCartArgs> {
  override document = gql`
    mutation CreateCart($input: CreateCartInput!) {
      createCart(input: $input) {
        cart {
          id
          numberOfItems
        }
      }
    }
  `;
}
